export const UPDATE_TOC = 'UPDATE_TOC';
export const RECEIVE_DOC = 'RECEIVE_DOC';
export const RECEIVE_OBJECT_URL = 'RECEIVE_OBJECT_URL';
export const SET_NETWORK_STATE = 'SET_NETWORK_STATE';
export const LOAD_ACCOUNT = 'LOAD_ACCOUNT';
export const SET_TOC_COLLAPSED = 'SET_TOC_COLLAPSED';